import React, { useState } from 'react';
import { Copy, Download } from 'lucide-react';

/**
 * Codes de secours de la double authentification (T15) : montrés une seule fois. « Continuer » n'est possible qu'après
 * avoir confirmé les avoir mis en lieu sûr.
 */
export default function BackupCodes({ codes, onContinue, buttonClass = 'btn btn-primary btn-sm', continueLabel = 'Continuer' }) {
  const [saved, setSaved] = useState(false);
  const [copied, setCopied] = useState(false);
  const text = `Codes de secours Colis2Ship (chacun ne sert qu'une fois)\n\n${codes.join('\n')}\n`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
    } catch { /* copie refusée par le navigateur : le téléchargement reste possible */ }
  };

  const download = () => {
    const url = URL.createObjectURL(new Blob([text], { type: 'text/plain' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = 'colis2ship-codes-de-secours.txt';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="mfa-backup-codes">
      <p style={{ fontSize: 13, margin: '0 0 10px' }}>
        <strong>Vos codes de secours.</strong> Si vous perdez votre téléphone, chacun remplace une fois le code de
        l'application. Ils ne seront plus affichés : gardez-les en lieu sûr.
      </p>
      <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 12px', display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 6,
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace', fontSize: 14, letterSpacing: 1 }}>
        {codes.map((c) => <li key={c} data-testid="mfa-backup-code">{c}</li>)}
      </ul>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
        <button type="button" className="btn btn-ghost btn-sm" onClick={copy}><Copy size={13} aria-hidden="true" /> {copied ? 'Copiés' : 'Copier'}</button>
        <button type="button" className="btn btn-ghost btn-sm" onClick={download}><Download size={13} aria-hidden="true" /> Télécharger</button>
      </div>
      <label style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: 13, marginBottom: 12 }}>
        <input type="checkbox" checked={saved} onChange={(e) => setSaved(e.target.checked)} data-testid="mfa-backup-saved" />
        J'ai mis ces codes en lieu sûr
      </label>
      <button type="button" className={buttonClass} disabled={!saved} onClick={onContinue} data-testid="mfa-backup-continue">
        {continueLabel}
      </button>
    </div>
  );
}
